import SupraLockbox from '@bb/domain/dist/types/SupraLockbox';
import Tag from 'components/Tag';
import React from 'react';
import styled from 'styled-components';

const ResaleStatusTag: React.FC<{
  resaleStatus?: SupraLockbox['resaleStatus'];
}> = ({ resaleStatus }) => {
  if (resaleStatus) {
    const statusColorMap: Record<string, string> = {
      Available: 'green',
      Leased: 'gold',
    };
    return (
      <StyledTag color={statusColorMap[resaleStatus] ?? 'red'}>
        {resaleStatus}
      </StyledTag>
    );
  }

  return null;
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default ResaleStatusTag;
